module.exports = __webpack_public_path__ + "img/chaos_knight.c6b32ca9.png";